import { useChatWidgetContext } from '@features/chat/context'
import { Info, Save } from 'lucide-react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

export interface FloatingSaveProps {
  discard: () => void
}

export function FloatingSave({ discard }: FloatingSaveProps) {
  const { t } = useTranslation('application')
  const { setSaveBarVisible } = useChatWidgetContext()

  useEffect(() => {
    setSaveBarVisible(true)
    return () => setSaveBarVisible(false)
  }, [setSaveBarVisible])

  return (
    <div className="sticky bottom-4 z-[1000] mx-auto mt-4 flex w-fit max-w-[calc(100%-1rem)] items-center gap-2 rounded-full border border-white/10 bg-primary p-2 text-white shadow-[0_16px_40px_rgba(17,173,187,0.35)] sm:gap-4 sm:pl-5">
      <span className="hidden items-center gap-2 text-sm font-medium text-white sm:flex">
        <Info className="h-4 w-4 shrink-0 text-white" />
        {t('floatingSave.changesDetected')}
      </span>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={discard}
          className="border border-white/70 bg-transparent text-white hover:bg-white hover:text-primary"
        >
          {t('floatingSave.discardChanges')}
        </Button>
        <Button
          type="submit"
          size="sm"
          className="bg-white font-semibold text-primary hover:bg-white/90 hover:text-primary"
        >
          <Save className="h-4 w-4" />
          {t('floatingSave.saveChanges')}
        </Button>
      </div>
    </div>
  )
}
